// @ts-ignore
// @ts-nocheck
import { isAfter } from 'date-fns';
import moment from 'moment';

export function getRangeDateRefuel(
  forecastDate,
  beginDate = null,
  endDate = null,
  suggestedDate = null,
  agreedDate = null,
  reprogrammingDate = null,
  deliveryDate = null,
  status = null
) {
  const beginDateObj = beginDate ? new Date(beginDate) : null;
  const endDateObj = endDate ? new Date(endDate) : null;

  if (status === 'Em analise') {
    return '';
  }

  if (status === 'Reprogramado' && reprogrammingDate) {
    return moment(reprogrammingDate).format('DD/MM/YY');
  }

  if (!beginDate && !endDate) {
    if (!forecastDate && agreedDate) {
      return moment(agreedDate).format('DD/MM/YY');
    }
    if (!forecastDate && !agreedDate) {
      return moment(suggestedDate).format('DD/MM/YY');
    }
    return moment(forecastDate).format('DD/MM/YY');
  }

  if (isAfter(endDateObj, beginDateObj)) {
    return `${moment(beginDateObj).format('DD/MM/YY')} a ${moment(
      endDateObj
    ).format('DD/MM/YY')}`;
  }

  if (!forecastDate && agreedDate) {
    return moment(agreedDate).format('DD/MM/YY');
  }
  if (!forecastDate && !agreedDate) {
    return moment(suggestedDate).format('DD/MM/YY');
  }
  return moment(forecastDate).format('DD/MM/YY');
}
